const API_KEY = process.env.REACT_APP_API_KEY
const API_BASE_URL = process.env.REACT_APP_GRAPHICS_API_URL || '';

class SelfcareApiService {
  constructor() {
    this.siteInfo = null;
    this.queue = [];
  }

  setSiteInfo(siteInfo) {
    this.siteInfo = siteInfo;
    this.processQueue();
  }

  processQueue() {
    if (this.queue.length > 0 && this.siteInfo?.id) {
      this.queue.forEach(({ method, args }) => {
        this[method](...args);
      });
      this.queue = [];
    }
  }

  addToQueue(method, args) {
    this.queue.push({ method, args });
  }

  async makeRequest(endpoint, data) {
    const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...data,
        signboard: this.siteInfo?.id,
        api_key: API_KEY
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  async sendLink(email, recaptchaToken) {
    if (!this.siteInfo?.id) {
      return new Promise((resolve, reject) => {
        this.addToQueue('sendLink', [email, recaptchaToken, resolve, reject]);
      });
    }

    try {
      const response = await this.makeRequest('send', {
        email,
        recaptchaToken
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  async getCards(token) {
    if (!this.siteInfo?.id) {
      return new Promise((resolve, reject) => {
        this.addToQueue('getCards', [token, resolve, reject]);
      });
    }

    try {
      const response = await this.makeRequest('cards', { token });
      return response;
    } catch (error) {
      throw error;
    }
  }

  async logout(token) {
    if (!this.siteInfo?.id) {
      return new Promise((resolve, reject) => {
        this.addToQueue('logout', [token, resolve, reject]);
      });
    }

    try {
      const response = await this.makeRequest('logout', { token });
      return response;
    } catch (error) {
      throw error;
    }
  }

  async activatePhysicalCard(card) {
    if (!this.siteInfo?.id) {
      return new Promise((resolve, reject) => {
        this.addToQueue('activatePhysicalCard', [card, resolve, reject]);
      });
    }

    try {
      const response = await this.makeRequest('card/activate', { card });
      return response;
    } catch (error) {
      throw error;
    }
  }

  async convertPhysicalCard(card) {
    if (!this.siteInfo?.id) {
      return new Promise((resolve, reject) => {
        this.addToQueue('convertPhysicalCard', [card, resolve, reject]);
      });
    }

    try {
      const response = await this.makeRequest('card/convert', { card });
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export const selfcareApi = new SelfcareApiService();

export function useSelfcareApi() {
  return selfcareApi;
}